import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../App";
import "../components/Header/Header.scss";

const BreadcrumbsMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [currPath, setCurrPath] = useState(null);
    const [parentRoute, setParentRoute] = useState("*");

    useEffect(() => {
        setParentRoute("*");
        setCurrPath(null);
        routes.forEach((el) => {
            const routing = `/${el.path}`;
            if (el.headerName && routing === location.pathname) {
                setParentRoute(el.path);
                setCurrPath(el.headerName);
            }
        });
    }, [location.pathname]);

    const handleRouteClick = () => {
        navigate(`/${parentRoute}`);
    };

    return (
        <div className="bredcrum-header flex flex-wrap items-center">
            <span
                className="font-semibold text-base pr-6 cursor-pointer"
                style={{ color: "#1D2965" }}
                onClick={handleRouteClick}
            >
                {currPath}
            </span>
        </div>

    );
};

export default BreadcrumbsMenu;
